import {getPrivateAxios} from '@blesk-frontend/api';

export interface BillingOrder {
  id: string;
  status: 'created' | 'completed' | 'canceled' | 'failed';
  type: 'initial' | 'renewal';
  teamId: string;
  planId: string;
  createdAt: string;
  expiresAt: string;
}

interface BillingSubscribeDto {
  planId: string;
}

export const fetchBillingSubscribe = async (createDto: BillingSubscribeDto) => {
  const {data} = await getPrivateAxios().post<BillingOrder>('/billing/subscribe', createDto);
  return data;
};
